import { trimmedTextRenderer } from './trimmedTextRenderer';
var textCellRenderer = function (_a) {
    var cellData = _a.cellData, columnWidth = _a.columnWidth, disabled = _a.disabled, inactive = _a.inactive, tooltipMaxWidth = _a.tooltipMaxWidth;
    return trimmedTextRenderer({ cellData: cellData, columnWidth: columnWidth, disabled: disabled, inactive: inactive, tooltipMaxWidth: tooltipMaxWidth });
};
export default textCellRenderer;
//# sourceMappingURL=textCellRenderer.js.map